import { useCallback } from 'react';
import { useAuth } from './use-auth';

interface UserProfile {
  full_name: string | null;
  profile_type: 'individual' | 'company' | 'driver' | null;
  bio: string | null;
  avatar_url: string | null;
  mobile: string | null;
}

interface UseProfileCompletionReturn {
  isProfileComplete: boolean;
  isLoading: boolean;
  needsCompletion: boolean;
  profile: UserProfile | null;
  refetchProfile: () => Promise<void>;
}

export function useProfileCompletion(): UseProfileCompletionReturn {
  const { user, isLoading: authLoading, isAuthenticated, refetch } = useAuth();

  const profile: UserProfile | null = user ? {
    full_name: (user as any).full_name ?? (user as any).fullName ?? null,
    profile_type: (user as any).profile_type ?? null,
    bio: (user as any).bio ?? null,
    avatar_url: (user as any).avatar_url ?? null,
    mobile: (user as any).mobile ?? null,
  } : null;

  const refetchProfile = useCallback(async () => {
    refetch();
  }, [refetch]);

  const isProfileComplete = Boolean(
    profile?.full_name && 
    profile.full_name.trim().length > 0
  );

  const needsCompletion = isAuthenticated && !isProfileComplete && !authLoading;

  return {
    isProfileComplete,
    isLoading: authLoading,
    needsCompletion,
    profile,
    refetchProfile,
  };
}
